import { Video } from './Video';
import { AcademyRedirectLink } from '../../dynamicContentWidget/components/AcademyRedirectLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VideoSection = ({
  autoPlay,
  isResizeReady = true,
  lessonId,
  contentId,
  shortId,
  videoTimestamp,
  isPublic = false,
  language,
  link,
  mutedByDefault,
  onLinkClick,
  onProgress,
  onWatermarkClick,
  onPlay,
  onFinish,
  onEngagement,
  openLinksInNewTab,
  renderContext = 'embedded-academy',
  creatorHubId,
  enablePictureInPicture,
  hublet,
  videoType,
  clipRange,
  linkTextProps,
  videoWrapperProps
}) => {
  return /*#__PURE__*/_jsxs("section", {
    children: [/*#__PURE__*/_jsx(Video, {
      autoPlay: autoPlay,
      clipRange: clipRange,
      contentId: contentId,
      creatorHubId: creatorHubId,
      enablePictureInPicture: enablePictureInPicture,
      hublet: hublet,
      isPublic: isPublic,
      language: language,
      lessonId: lessonId,
      link: link,
      mutedByDefault: mutedByDefault,
      onEngagement: onEngagement,
      onFinish: onFinish,
      onPlay: onPlay,
      onProgress: onProgress,
      onWatermarkClick: onWatermarkClick,
      openLinksInNewTab: openLinksInNewTab,
      renderContext: renderContext,
      shortId: shortId,
      startTime: videoTimestamp,
      videoType: videoType,
      videoWrapperProps: videoWrapperProps
    }), isResizeReady !== false && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(AcademyRedirectLink, {
        contentId: contentId,
        isPublic: isPublic,
        lessonId: lessonId,
        link: link,
        linkTextProps: linkTextProps,
        onClick: onLinkClick,
        openLinksInNewTab: openLinksInNewTab,
        shortId: shortId
      })
    })]
  });
};